import { render, staticRenderFns } from "./multipleChoiceQuestion.vue?vue&type=template&id=684907e4&"
import script from "./multipleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./multipleChoiceQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684907e4')) {
      api.createRecord('684907e4', component.options)
    } else {
      api.reload('684907e4', component.options)
    }
    module.hot.accept("./multipleChoiceQuestion.vue?vue&type=template&id=684907e4&", function () {
      api.rerender('684907e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/multipleChoiceQuestion.vue"
export default component.exports